<div class="app-content content bg-full-screen-image" *ngIf="isPageLoaded">
    <div class="content-wrapper">
        <div class="content-header row">
        </div>
        <div class="content-body">
            <section class="row flexbox-container">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
                        <div class="card border-grey border-lighten-5 m-0 card-transparent">
                            <div class="card-header border-0">
                                <button class="btn btn-icon rounded-circle btn-grey mr-1 mb-1" (click)="back()"> 
                                    <i class="feather ft-arrow-left font-weight-bold"></i>
                                </button>
                                <div class="card-title text-center">
                                    <img src="https://res.cloudinary.com/drtcnv1st/image/upload/v1679330333/Custom/logo-sate_by7hwg.png" alt="branding logo" width="60px" height="60px">
                                    <br>
                                    <h6 class="card-title title">Sistema de Seguimiento y <br>Apoyo de Trabajo a Egresados</h6>
                                </div>
                            </div>
                            <div class="card-content">
                                <br>
                                <h3 class="text-center card-title user">Docente</h3>
                                <h5 class="card-title text-muted text-center mx-2 my-2">Ingresa tus credenciales</h5>
                                <hr>
                                <div class="card-body">
                                    <form class="form-horizontal" [formGroup]="loginProfessorForm" (ngSubmit)="tryLogin()">
                                        <fieldset class="form-group position-relative has-icon-left">
                                            <input type="text" formControlName="usuario" autocomplete="username"  class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && f.usuario.errors }" id="user-name"
                                                placeholder="Usuario" required>
                                            <div class="form-control-position">
                                                <i class="la la-user icon dark"></i>
                                            </div>
                                            <div *ngIf="submitted && f.usuario.errors" class="invalid-feedback">
                                                <div *ngIf="f.usuario.errors.required">Escribe el usuario.</div>
                                            </div>
                                        </fieldset>
                                        <fieldset class="form-group position-relative has-icon-left">
                                            <input type="password" placeholder="Contraseña" autocomplete="current-password"
                                                formControlName="password" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                            <div class="form-control-position">
                                                <i class="la la-key icon dark"></i>
                                            </div>
                                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                                <div *ngIf="f.password.errors.required">Escribe la contraseña.</div>
                                            </div>

                                        </fieldset>
                                        <button type="submit" class="btn btn-dark btn-block btn-round" [disabled]="isProcessing">
                                            <i class="la la-refresh fa-spin" *ngIf="submitted"></i>
                                            <i class="feather ft-unlock" *ngIf="!submitted"></i> Acceder
                                        </button>
                                    </form>
                                </div>
                                <!-- <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <a [routerLink]="['/privacypolicy']" target="_blank">Politica de Privacidad</a>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
<!-- <app-public-footer></app-public-footer> -->
